export default function PrinciperModal({ onClose }) {
  const metoder = [
    {
      number: "01",
      title: "IPS – Individanpassat stöd till arbete",
      intro:
        "IPS (Individual Placement and Support) är ett arbetssätt som utgår från att människor ska få stöd att närma sig arbete eller studier utifrån sina egna mål, förutsättningar och önskemål.",
      text: [
        "En central utgångspunkt är att arbete och studier kan vara en del av vägen framåt, även när en person samtidigt behöver stöd inom andra områden i livet. Därför försöker vi inte först lösa alla andra problem innan vi pratar om arbete eller studier.",
        "I stället arbetar vi parallellt med individens mål och de stödbehov som finns. Vi tar utgångspunkt i personens intressen, styrkor och tidigare erfarenheter och försöker hitta realistiska möjligheter på den ordinarie arbets- och utbildningsmarknaden.",
        "En viktig del av arbetssättet är också det långsiktiga stödet. Vägen mot arbete eller studier ser olika ut för olika personer och kan innehålla både framsteg och bakslag. Stödet anpassas därför efter individens situation och förändras när behoven förändras.",
      ],
      principles: [
        "Individens egna mål och önskemål står i centrum.",
        "Arbete och studier ses som möjliga mål tidigt i processen.",
        "Stödet anpassas efter individens behov och förutsättningar.",
        "Vi utgår från den ordinarie arbets- och utbildningsmarknaden.",
        "Stöd ges även efter att personen har tagit nästa steg.",
      ],
    },

    {
      number: "02",
      title: "Tjänstedesign – utveckling tillsammans med dem det berör",
      intro:
        "Tjänstedesign är ett arbetssätt för att förstå människors behov och utveckla insatser tillsammans med dem som använder eller påverkas av dem.",
      text: [
        "I projektet använder vi tjänstedesign för att undersöka hur stödet upplevs av unga och av de verksamheter som möter dem. Genom att lyssna, observera och ställa frågor försöker vi förstå både vad som fungerar och var det uppstår hinder.",
        "En viktig del är att inte utgå från att vi redan vet vad som är problemet eller vilken lösning som behövs. I stället börjar vi med människors erfarenheter och använder dem som underlag för utveckling.",
        "Arbetet kan innebära att identifiera behov, visualisera en persons väg genom olika verksamheter, testa idéer och tillsammans utveckla nya lösningar. På så sätt kan vi upptäcka sådant som annars riskerar att falla mellan olika verksamheters ansvarsområden.",
        "Tjänstedesign hjälper oss alltså att gå från antaganden till ökad förståelse – och från förståelse till konkreta förbättringar.",
      ],
      principles: [
        "Vi utgår från människors faktiska erfarenheter.",
        "De som berörs av en insats involveras i utvecklingsarbetet.",
        "Vi undersöker både behov, hinder och möjligheter.",
        "Idéer testas och utvecklas stegvis.",
        "Lösningar skapas tillsammans snarare än åt någon annan.",
      ],
    },

    {
      number: "03",
      title: "Följeforskning – lärande under projektets gång",
      intro:
        "Följeforskning innebär att projektet följs och analyseras under genomförandet. Syftet är inte bara att bedöma resultat i efterhand, utan att skapa lärande medan projektet fortfarande pågår.",
      text: [
        "Genom följeforskningen får projektet möjlighet att stanna upp, undersöka vad som händer och reflektera över varför. Det kan handla om vad som fungerar väl, vilka utmaningar som uppstår och hur olika arbetssätt påverkar deltagare och samverkande verksamheter.",
        "Följeforskningen bidrar med ett utifrånperspektiv och hjälper projektet att se sådant som kan vara svårt att upptäcka när man själv är mitt i arbetet. Resultaten kan sedan användas för att justera arbetssätt, utveckla samverkan och stärka projektets lärande.",
        "På så sätt blir uppföljning och utvärdering en del av det löpande utvecklingsarbetet. Vi försöker inte bara svara på frågan om något fungerar, utan också förstå vad som gör skillnad, för vem och under vilka förutsättningar.",
      ],
      principles: [
        "Vi följer projektets utveckling under hela genomförandet.",
        "Erfarenheter och resultat används för kontinuerligt lärande.",
        "Ett utifrånperspektiv kompletterar projektets egna erfarenheter.",
        "Vi undersöker både resultat och hur arbetet genomförs.",
        "Kunskap används för att utveckla projektet under vägen.",
      ],
    },
  ];

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div
        className="relative w-full max-w-6xl max-h-[90vh] overflow-y-auto bg-white rounded-[2rem] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Close */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-5 right-5 z-10 w-11 h-11 rounded-full bg-black text-white flex items-center justify-center hover:scale-105 transition"
          aria-label="Stäng"
        >
          <span className="text-xl leading-none">×</span>
        </button>

        {/* CONTENT */}
        <div className="p-8 md:p-12 lg:p-16">

          {/* INTRO */}
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-black/50 mb-3">
            01 · Så arbetar vi
          </p>

          <h2 className="text-3xl md:text-4xl font-semibold text-[#222] max-w-3xl">
            Tre metoder – ett gemensamt arbetssätt
          </h2>

          <p className="mt-5 max-w-3xl text-[#555] leading-relaxed">
            Projektet kombinerar individnära stöd med utveckling och lärande.
            IPS, tjänstedesign och följeforskning kompletterar varandra och
            hjälper oss att både möta individens behov och utveckla hur
            verksamheter arbetar tillsammans.
          </p>

          {/* METODER */}
          <div className="mt-12">

            {metoder.map((metod, index) => (
              <section
                key={metod.title}
                className={`${
                  index !== 0 ? "border-t border-black/10 pt-12" : ""
                } ${index !== metoder.length - 1 ? "pb-12" : ""}`}
              >

                {/* LABEL */}
                <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-2">
                  Metod {metod.number}
                </p>

                {/* TITLE */}
                <h3 className="text-2xl font-semibold text-[#222] mb-5">
                  {metod.title}
                </h3>

                {/* INTRO */}
                <p className="text-base font-medium leading-7 text-[#333] mb-5 max-w-4xl">
                  {metod.intro}
                </p>

                {/* TEXT */}
                <div className="space-y-4 max-w-4xl">
                  {metod.text.map((paragraph) => (
                    <p
                      key={paragraph}
                      className="text-[#555] leading-relaxed"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>

                {/* CENTRALA UTGÅNGSPUNKTER */}
                <div className="mt-7 p-5 rounded-2xl bg-[#f5f3ef] max-w-4xl">
                  <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-4">
                    Centrala utgångspunkter
                  </p>

                  <ul className="space-y-3">
                    {metod.principles.map((principle) => (
                      <li
                        key={principle}
                        className="flex gap-3 text-sm leading-6 text-[#555]"
                      >
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#3BAFA3]" />
                        <span>{principle}</span>
                      </li>
                    ))}
                  </ul>
                </div>

              </section>
            ))}

          </div>

          {/* AVSLUTANDE REFLEKTION */}
          <section className="border-t border-black/10 pt-10">

            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-black/45 mb-2">
              Tillsammans
            </p>

            <div className="mt-6 p-5 rounded-2xl bg-[#f5f3ef] max-w-4xl">
              <p className="text-lg font-semibold text-[#222] leading-relaxed">
                Metoderna fyller olika funktioner men hänger ihop. IPS ger
                struktur för det individnära stödet, tjänstedesign hjälper oss
                att förstå och utveckla stödet tillsammans med dem som berörs,
                och följeforskningen bidrar med analys och lärande under vägen.
                Tillsammans skapar de en grund för att både stötta individen
                och utveckla verksamheten.
              </p>
            </div>

          </section>

        </div>
      </div>
    </div>
  );
}